// Master (internal kolula staff) can do everything a tenant Owner can.
//
// The backend already admits master on every permission check
// (`hasMasterRole` in new-backend `requireAnyPermission`). The admin UI gates
// on permission strings, and a master's strings come from the Auth0 token,
// which does not carry the newer ones (archive:issue-reports and the
// per-element strings of 2026-10-07) — so buttons the backend would accept
// were hidden from master. Granting the Owner set here, at the one point every
// permission source enters the store, closes that for every gate at once.
//
// Mirrors `permissionsForRole('owner')` in
// `new-backend/admin/src/lib/rolePermissions.ts`; its `masterGrant.test.ts`
// pins the two lists to each other.
export const OWNER_PERMISSIONS: readonly string[] = [
    'read:bookings',
    'show:booking',
    'read:issue-reports',
    'read:invoices',
    'create:issue-reports',
    'edit:issue-reports',
    'edit:damage-report',
    'read:lockers',
    'create:bookings',
    'edit:bookings',
    'archive:bookings',
    'anonymize:bookings',
    'archive:issue-reports',
    'export:issue-reports',
    'read:dashboard',
    'manage:invoices',
    'manage:products',
    'delete:products',
    'read:assets',
    'show:location',
    'edit:location',
    'edit:depot',
    'depots:read',
    'depots:write',
    'create:assets',
    'delete:assets',
    'show:technical-info',
    'read:vouchers',
    'view:voucher-history',
    'manage:vouchers',
    'manage:banners',
    'edit:deposit-settings',
    'customers:read',
    'customers:write',
];

/** Same match as `makeHasRoleSelector('master')`: case-insensitive substring. */
const isMasterRole = (roles: readonly string[]): boolean =>
    roles.some((role) => role.toLowerCase().includes('master'));

/** A master's permissions plus the Owner set; anyone else's unchanged. */
export const withMasterGrant = (permissions: readonly string[], roles: readonly string[]): string[] =>
    (isMasterRole(roles)
        ? Array.from(new Set([...permissions, ...OWNER_PERMISSIONS]))
        : [...permissions]);
